import { observer } from 'mobx-react';
import FormCommon from '@/components/FormCommon';
import {
  SelectItem,
  CheckboxItem,
  InputItem,
  BaseItem,
} from '@/components/FormItem';
import { $fm } from '@/Intl';
import { useScreensaver, useLocalImg } from '@/store';
import LocalImgUpload from './LocalImgUpload';

export default observer(() => {
  const [screensaver, updateScreensaver, defaults] = useScreensaver();
  const [, setLocalImg] = useLocalImg();

  return (
    <FormCommon
      initialValues={screensaver}
      onUpdate={updateScreensaver}
      defaults={defaults}
      onReset={() => {
        setLocalImg(null);
      }}
    >
      {/* 屏保类型 */}
      <SelectItem
        label={$fm('SCREEN_SAVER_TYPE')}
        name='saverType'
        options={[
          { v: 1, t: $fm('SCREEN_SAVER_DEFAULT') },
          { v: 2, t: $fm('SCREEN_SAVER_CLOCK') },
        ]}
        onChange={(v) => {
          if (v !== 1) {
            setLocalImg(null);
          }
        }}
      />

      {/* 屏保 */}
      <SelectItem
        label={$fm('SCREEN_SAVER')}
        name='screenType'
        options={[
          { v: 2, t: $fm('DEFAULT_DIR') },
          { v: 3, t: $fm('LOCAL_IMG') },
          { v: 6, t: $fm('NET_IMG') },
        ]}
        onChange={(v) => {
          if (v !== 3) {
            setLocalImg(null);
          }
        }}
        depends={{
          saverType: 1,
        }}
      />

      {/* 本地图片 */}
      <BaseItem
        label={$fm('LOCAL_IMG')}
        name='localImg'
        depends={{
          saverType: 1,
          screenType: 3,
        }}
      >
        <LocalImgUpload />
      </BaseItem>

      {/* 网络图片地址 */}
      <InputItem
        name='netImg'
        label={$fm('NET_IMG_ADDRESS')}
        depends={{
          saverType: 1,
          screenType: 6,
        }}
      />
      {/* 屏幕超时 */}
      <SelectItem
        name='screenLcdOff'
        label={$fm('SCREEN_SAVER_LCDOFF')}
        options={[
          { v: 120, t: $fm('MINUTES', { n: '2' }) },
          { v: 180, t: $fm('MINUTES', { n: '3' }) },
          { v: 300, t: $fm('MINUTES', { n: '5' }) },
          { v: 600, t: $fm('MINUTES', { n: '10' }) },
          { v: 1200, t: $fm('MINUTES', { n: '20' }) },
          { v: 1800, t: $fm('MINUTES', { n: '30' }) },
          { v: 3600, t: $fm('MINUTES', { n: '60' }) },
          { v: -1, t: $fm('NEVER') },
        ]}
        depends={{
          saverType: 1,
        }}
      />
      {/* 屏保超时时间 */}
      <SelectItem
        name='screenTime'
        label={$fm('SCREEN_SAVER_TIME')}
        options={[
          { v: 15, t: $fm('SECONDS', { n: '15' }) },
          { v: 30, t: $fm('SECONDS', { n: '30' }) },
          { v: 60, t: $fm('MINUTE', { n: '1' }) },
          { v: 120, t: $fm('MINUTES', { n: '2' }) },
          { v: 300, t: $fm('MINUTES', { n: '5' }) },
          { v: 600, t: $fm('MINUTES', { n: '10' }) },
          { v: 1200, t: $fm('MINUTES', { n: '20' }) },
          { v: 1800, t: $fm('MINUTES', { n: '30' }) },
          { v: -1, t: $fm('NEVER') },
        ]}
        depends={{
          saverType: 1,
        }}
      />
      {/* 动画间隔时间 */}
      <SelectItem
        name='screenInterval'
        label={$fm('SCREEN_SAVER_INTERVAL')}
        options={[
          { v: 3, t: $fm('SECONDS', { n: '3' }) },
          { v: 5, t: $fm('SECONDS', { n: '5' }) },
          { v: 8, t: $fm('SECONDS', { n: '8' }) },
          { v: 10, t: $fm('SECONDS', { n: '10' }) },
        ]}
        depends={{
          saverType: 1,
        }}
      />
      {/* 样式 */}
      <SelectItem
        name='clockType'
        label={$fm('TYPE')}
        options={[
          { v: 1, t: $fm('ANALOG_CLOCK') },
          { v: 2, t: $fm('DIGIT_CLOCK') },
        ]}
        depends={{
          saverType: 2,
        }}
      />
      {/* 夜间模式 */}
      <CheckboxItem
        label={$fm('NIGHT_MODE')}
        name='nightMode'
        depends={{
          saverType: 2,
        }}
      />
    </FormCommon>
  );
});
